import React, { useMemo } from 'react';

const KIPTableCardService = (props: any) => {
  const { data, children, selectorList, ...restProps } = props;

  const getTableItem = (metrics: any, selectorList: any, game_list: any, gameCode: string) => {

    // 配置拿图标+名称
    const game = selectorList?.find((item: any, index: number) => index !== 0 && item?.key === gameCode);
    // 接口拿名称+图片兜底
    const apiGame = game_list?.find((item: any) => item?.game_code === gameCode);

    const { game_name, game_name_cn, entity_image } = apiGame || {};
    const { textEn, textCn, img } = game || {};
    const obj = {
      nameEn: textEn || game_name,
      nameCn: textCn || game_name_cn,
      img: img || entity_image,
    };

    Object.keys(metrics)?.forEach(key => {
      const metricsData = metrics[key];
      Object.keys(metricsData).forEach(valueKey => {
        const attrData = metricsData[valueKey];
        Object.keys(attrData).forEach(attrKey => {
          obj[`${key}_${valueKey}_${attrKey}`] = attrData[attrKey];
        });
      });
    });

    return obj;
  };

  const tableData = useMemo(() => {
    // 数据合并
    // const { AllGameData, DL2GaaSGameData, studioData, AllGameUnitData } = data;
    const { AllGameData, studioData, AllGameUnitData } = data;
    const { game_list = [] } = studioData || {};

    // 合并revenue和unit的数据
    const newAllGameData = AllGameData?.data?.map((item: any) => {
      const { game_code, metrics } = item;
      const unitMetrics = AllGameUnitData?.data?.find((unitItem: any) => unitItem?.game_code === game_code)?.metrics || {};
      return {
        ...item,
        metrics: {
          ...metrics,
          ...unitMetrics,
        },
      };
    });

    // 合并AllGameData和DL2GaaSGameData的数据
    const allData = [...(newAllGameData || [])]?.map((item: any) => {
      const { game_code: gameCode, metrics } = item;
      const obj = getTableItem(metrics, selectorList, game_list, gameCode) || {};
      return obj;
    });
    // const dl2GaasData = (DL2GaaSGameData.data || [])?.map((item: any) => {
    //   const { game_code: gameCode, metrics } = item;
    //   const obj = getTableItem(metrics, selectorList, game_list, `${gameCode}Gaas`) || {};
    //   return obj;
    // });
    
    // gaas插入在倒数第二位
    // allData?.splice(allData?.length - 1, 0, ...(dl2GaasData || []));

    return allData;
  }, [data, selectorList]);

  return React.Children.map(children, (child: any) =>
    React.cloneElement(child, {
      ...(restProps || {}),
      tableData,
    }),
  );
};

export default KIPTableCardService;
